import {
  GET_CONFIG_COLOR,
  SET_CONFIG_COLOR,
} from "../constants/config-color-constants";

export const getConfigColorData = () => ({
  type: GET_CONFIG_COLOR,
});

export const setConfigColorData = (color) => ({
  type: SET_CONFIG_COLOR,
  color,
});
